"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UseCaseDfsIterable = exports.UseCaseGraph = void 0;
const tslib_1 = require("tslib");
const Utilities_1 = require("../../../TdWebtoolkitControls/javascript/Utilities");
const UseCase_1 = require("./UseCase");
const Instance_1 = require("../../../TdWebtoolkitControls/model/Instance");
class UseCaseEdge {
    constructor(m_idFrom, m_idTo) {
        "Method not implemented.";
        this.m_idFrom = m_idFrom;
        this.m_idTo = m_idTo;
    }
}
class UseCaseGraph {
    constructor() {
        this.m_mapNodes = {};
        this.m_edges = [];
    }
    static getIconIdForFtEntry(ftEntry) {
        if (ftEntry.ceimage)
            return parseInt(ftEntry.ceimage.toString(), 10);
        return undefined;
    }
    static createAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let userInfo = Utilities_1.synUtil.UserInfo.getUserInfo();
            let graph = new UseCaseGraph();
            let mapGroups = yield UseCaseGraph.getGroupsAsync();
            for (let groupId in mapGroups) {
                let groupObj = mapGroups[groupId];
                let groupNode = UseCase_1.UseCaseGraphNode.GetGroupNode(groupId, groupObj.name, groupObj.comments, this.getIconIdForFtEntry(groupObj), groupObj.csscolor);
                let pidString = groupObj.pid || "";
                let pids = pidString.split("|");
                $.each(pids, (_idx, pid) => {
                    if (pid !== groupId) {
                        let parentGroupObj = mapGroups[pid];
                        if (typeof parentGroupObj === "undefined")
                            throw "Group (id=" + pid + ") does not exist.";
                        let parentGroupNode = UseCase_1.UseCaseGraphNode.GetGroupNode(pid, parentGroupObj.name, parentGroupObj.comments, this.getIconIdForFtEntry(parentGroupObj), parentGroupObj.csscolor);
                        graph.addEdge(parentGroupNode, groupNode);
                    }
                });
            }
            let graphJson = yield Utilities_1.synUtil.getAJAXDataAsync({
                url: Utilities_1.synUtil.getWSUrl("Graph"),
                method: "POST",
                requestData: JSON.stringify({
                    node: userInfo.Id,
                    parentDepth: 0,
                    childDepth: -1,
                    allowedCategories: ["999999913", "999999916"],
                    allFieldNames: true
                })
            });
            for (let i = 0; i < graphJson.nodes.length; ++i) {
                let curInst = yield Instance_1.Instance.fromJSON(graphJson.nodes[i].data.instance);
                if (curInst.items["cgdocument.typeid"].valueToString() === "999999916") {
                    let dataObj = undefined;
                    let jsonData = curInst.items["ceusecase.jsondata"].valueAsString;
                    if (jsonData)
                        dataObj = JSON.parse(jsonData.toString());
                    let curNode = UseCase_1.UseCaseGraphNode.GetUseCase(curInst.items["cgdocument.docid"].valueToString(), curInst.name.valueAsString, curInst.items["cgdocument.doccomment"].valueAsString, dataObj);
                    graph.addNode(curNode);
                    $.each(curInst.items["ceusecase.groupid"].valueAsStringArray, (_idx, groupId) => {
                        let groupObj = mapGroups[groupId];
                        if (typeof groupObj === "undefined")
                            throw "Group (id=" + groupId + ") does not exist.";
                        graph.addEdge(UseCase_1.UseCaseGraphNode.GetGroupNode(groupId, groupObj.name, groupObj.comments, this.getIconIdForFtEntry(groupObj), groupObj.cssColor), curNode);
                    });
                }
            }
            graph.addVirtualRoot();
            return graph;
        });
    }
    descendants(options) {
        let actualOpts = {
            startNode: UseCase_1.UseCaseGraphNode.GetVirtualRoot(),
            nodeTypes: UseCase_1.UseCaseNodeType.Group | UseCase_1.UseCaseNodeType.UseCase | UseCase_1.UseCaseNodeType.VirtualRoot,
            recursive: false,
            removeDuplicates: false
        };
        if (options) {
            if (options.startNode)
                actualOpts.startNode = options.startNode;
            if (options.nodeTypes)
                actualOpts.nodeTypes = options.nodeTypes;
            if (options.recursive !== undefined)
                actualOpts.recursive = options.recursive;
            if (options.removeDuplicates !== undefined)
                actualOpts.removeDuplicates = options.removeDuplicates;
        }
        return Array.from(this.getDfsIterator(actualOpts));
    }
    outEdges(node) {
        let nodeId = UseCaseGraph.getInternalId(node);
        return this.m_edges.filter(edge => edge.m_idFrom === nodeId);
    }
    byInternalId(internalId) {
        return this.m_mapNodes[internalId] || undefined;
    }
    static getInternalId(node) {
        return node.m_type.toString() + "_" + node.m_id;
    }
    debug() {
        let useCaseColor = "#b5d2ff";
        let groupColor = "#c1ffc6";
        let virtualRootColor = "#ffe9c1";
        let dotGraph = "digraph useCaseForest {\r\n   ratio = fill\r\n   node [style=filled]\r\n";
        for (let id in this.m_mapNodes) {
            let node = this.m_mapNodes[id];
            dotGraph += "   _" + id;
            let color = useCaseColor;
            if (node.m_type === UseCase_1.UseCaseNodeType.VirtualRoot)
                color = virtualRootColor;
            else if (node.m_type === UseCase_1.UseCaseNodeType.Group)
                color = groupColor;
            dotGraph += " [label=\"" + node.m_name + "\", color=\"" + color + "\"]\r\n";
        }
        for (let edge of this.m_edges)
            dotGraph += "   _" + edge.m_idFrom + " -> _" + edge.m_idTo + "\r\n";
        dotGraph += "}";
    }
    getDfsIterator(options) {
        return new UseCaseDfsIterable(options, this);
    }
    static getGroupsAsync() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let mapGroups = {};
            let groups = yield Utilities_1.synUtil.getAJAXDataAsync({
                method: "POST",
                url: Utilities_1.synUtil.getWSUrl("ForeigntableEntries") + "dzvusecasegroup/"
            });
            if (groups.items)
                $.each(groups.items, (_idx, item) => { mapGroups[item.id] = item; });
            return mapGroups;
        });
    }
    addNode(node) {
        let id = UseCaseGraph.getInternalId(node);
        if (typeof this.m_mapNodes[id] === "undefined")
            this.m_mapNodes[id] = node;
    }
    addEdge(start, end) {
        this.addNode(start);
        this.addNode(end);
        let idFrom = UseCaseGraph.getInternalId(start);
        let idTo = UseCaseGraph.getInternalId(end);
        if (this.m_edges.findIndex((e) => e.m_idFrom === idFrom && e.m_idTo === idTo) === -1)
            this.m_edges.push(new UseCaseEdge(idFrom, idTo));
    }
    addVirtualRoot() {
        let mapIdsWithNoIncomingEdges = {};
        for (let nodeId in this.m_mapNodes)
            mapIdsWithNoIncomingEdges[nodeId] = true;
        $.each(this.m_edges, (_idx, edge) => {
            delete mapIdsWithNoIncomingEdges[edge.m_idTo];
        });
        for (let id in mapIdsWithNoIncomingEdges) {
            let virtualRoot = UseCase_1.UseCaseGraphNode.GetVirtualRoot();
            this.addEdge(virtualRoot, this.m_mapNodes[id]);
        }
    }
}
exports.UseCaseGraph = UseCaseGraph;
class UseCaseDfsIterable {
    constructor(m_options, m_graph) {
        this.m_options = m_options;
        this.m_graph = m_graph;
        this.m_currentEdge = undefined;
        this.m_stack = [];
        this.m_edgeStack = [];
        this.m_visitedNodes = {};
        this.queueNext(m_options.startNode);
    }
    get currentEdge() {
        return this.m_currentEdge;
    }
    next() {
        while (this.m_stack.length) {
            let cur = this.m_stack.pop();
            this.m_currentEdge = this.m_edgeStack.pop();
            if (this.m_options.recursive)
                this.queueNext(cur);
            let internalId = UseCaseGraph.getInternalId(cur);
            let matchesTypes = (cur.m_type & this.m_options.nodeTypes);
            let filteredAsDuplicate = this.m_options.removeDuplicates && this.m_visitedNodes[internalId];
            this.m_visitedNodes[internalId] = true;
            if (matchesTypes && !filteredAsDuplicate)
                return { value: cur, done: false };
        }
        return { value: undefined, done: true };
    }
    queueNext(curNode) {
        for (let edge of this.m_graph.outEdges(curNode)) {
            let edgeTargetNode = this.m_graph.byInternalId(edge.m_idTo);
            if (edgeTargetNode === undefined)
                throw "Could not find node by internal id " + edge.m_idTo;
            this.m_stack.push(edgeTargetNode);
            this.m_edgeStack.push(edge);
        }
    }
    [Symbol.iterator]() { return this; }
}
exports.UseCaseDfsIterable = UseCaseDfsIterable;
